/* eslint-disable prefer-spread */
/* eslint-disable prefer-rest-params */
<template>
  <div id="app">
    <NavBar />
    <div class="maintenance-container" v-if="shutdown">
      <MaintenanceShutdownModal></MaintenanceShutdownModal>
    </div>
    <div class="content-container">
      <div class="app-content">
        <div
          class="st-section-playlistability"
          :class="visiblePanel==='playlistabilityIndex' ? 'results' : ''"
          :style="`--bg-image: ${visiblePanel==='playlistabilityIndex' ? 'url(' + songInfo.Image + ')' : 'none'}`"
        >
          <div class="body" v-if="visiblePanel=='playlistabilityIndex'">
            <div class="card playlistab-results">
              <div class="playlistability-container">
                <div class="gauge-container">
                  <Playlistability class="gauge"
                    :size="320"
                    :lowMarker="playlistability.lowMarker"
                    :highMarker="playlistability.highMarker"
                    :value="playlistability.value"
                    :ratingLabel="playlistability.ratingLabel"
                  />
                  <p class="playlistability-description">{{playlistability.description}}</p>

                </div>
                <div class="playlistability-details">
                  <div class="playlistability-songdata-holder">
                    <div class="playlistability-song-cover" :style="'background-image: url(' + songInfo.Image + ')'"></div>
                    <div class="playlistability-song-data">
                      <p class="playlistab-song-title">{{songInfo.Name}}</p>
                      <p class="playlistab-song-artist">{{songInfo.ArtistName}}</p>
                    </div>
                    <div class="playlistab-song-iconlink" @click.stop="openTrackInSpotify(songInfo.TrackId)"><font-awesome-icon :icon="['fab','spotify']" class="icon"></font-awesome-icon></div>
                  </div>
                  <div class="playlistability-song-details">
                    <div class="score-title">How does your track measure up?</div>
                    <div class="metric-suggestions score-block" v-for="(detail, index) in playlistabilityDetails.filter(item => item.Category!== 'General')" :key="'piDetail_' + index">
                      <div  v-if="detail.Category!='General'">
                        <div class="score-row">
                          <h6 class="category-info"><span class="info-icon"><font-awesome-icon :icon="['fas','info-circle']"></font-awesome-icon></span>{{detail.Category}} <div class="bubble"><span>{{getCategoryDescription(detail.Category)}}</span></div> </h6>
                          <bar-gauge :value="Math.round(detail.CategoryValue/10)" class="bar-gauge"></bar-gauge>
                        </div>
                        <div class="score-row">
                          <div class="playlista-description">{{detail.Descriptor}}</div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              <div class="playlistab-suggested-playlists-holder" v-if="suggestedPlaylists.length>0">
                <div class="score-title center">Active playlists for which you might be a good match</div>
                <div class="playlistab-subtitle">Based on your results, here's a few playlists where your track might make a good match:</div>
                <div class="st-suggested-playlists">
                  <div class="playlistability-songdata-holder lite" style="cursor: auto" v-for="(playlist, index) in suggestedPlaylists" :key="'playlist_' + index">
                    <div class="playlistability-song-cover" :style="'background-image: url(' + playlist.PlaylistImage + '), url(https://iili.io/HlHy9Yx.png)'">
                    </div>
                    <div class="playlistability-song-data">
                        <p class="playlistab-song-title mini">{{playlist.PlaylistName}}</p>
                        <p class="playlistab-song-artist">By <strong>{{playlist.PlaylisterName}}</strong></p>
                        <p class="playlistab-playlistist-followers">{{abbreviateNumber(playlist.PlaylistFollowers)}} </p>
                    </div>
                    <!-- <div class="playlistab-song-iconlink" @click.stop="openTrackInSpotify(songInfo.TrackId)">
                      <font-awesome-icon :icon="['fab','spotify']" class="icon"></font-awesome-icon>
                    </div> -->
                  </div>
                </div>
              </div>
              <div class="cta">
                <button class="btn-primary w-button" @click.stop="goToSignUp">Sign Up Today</button>
              </div>
            </div>
          </div>
          <div class="body request-code" v-else-if="visiblePanel=='requestCode'">
            <div class="card st-playlistability-hero playlistability-verification">
              <div class="st-hero-content-left verification">
                <div class="playlistability-title">Enter your access code</div>
                <div class="h3-slogan center">We've sent you an access code via email. Enter it below to access the playlistability index for your song.</div>
                <div class="code"><PincodeInput :autofocus="true"  v-model="verificationCode" placeholder="•"></PincodeInput></div>
                <p class="error" v-if="verificationError.length>0"><font-awesome-icon class="icon" :icon="['fas', 'exclamation-circle']"></font-awesome-icon>{{verificationError}}</p>
                <div><button class="btn-primary validate" @click.stop="validateCode" :disable="!enableValidation">Validate</button></div>
              </div>
            </div>
          </div>
          <div class="body request-info" v-else-if="visiblePanel=='requestInfo'">
            <div class="st-hero-content playlistability-center">
                <div class="st-hero-content-left playlistability">
                  <img src="@/assets/img/playlisterclub-logo-vector-light.svg" loading="lazy" alt="" class="service-logo-hero playlistability">
                  <h1 class="playlistabil-ity-title">How does your track measure up?</h1>
                  <h2 class="h3-slogan">
                    Our Playlistability Index is the most advanced metric to measure your song’s potential performance from a playlisting perspective. Using thousands of data points we collect daily, we’ve devised an engine to check your playlistability -- <strong>how playlistable your song is</strong> -- against what our playlisters are currently adding, and what other emerging artists like yourself scored.
                  </h2>
                  <div class="playlistability-form-container">
                    <div class="form-item-container">
                      <label for="">Spotify Song Link</label>
                      <input class="st-ui-input w-input" type="text" v-model="playlistabilityURL">
                    </div>
                    <div class="form-item-container">
                      <label for="">Email Address</label>
                      <input class="st-ui-input w-input" type="text" v-model="playlistabilityEmail">
                    </div>
                    <div class="error" v-if="playlistabilityError"><font-awesome-icon :icon="['fas','exclamation-circle']" class="icon"></font-awesome-icon>{{playlistabilityError}}</div>
                  </div>
                  <button class="btn-primary w-button" style="margin: 20px 0" @click.stop="onProcessPlaylistabilityIndex" :disabled="processing">Get your Playlistability Index</button>
                  <div class="input-note">
                    <em>Enter your Spotify Song URL and your email above to get your free results!</em>
                  </div>
                </div>
                <div class="floating-gauge"></div>
            </div>
          </div>
          <div class="body request-error" v-else-if="visiblePanel=='requestError'">
            <div class="card">
                <div class="columns">
                  <div class="content">
                    <font-awesome-icon :icon="['fas', 'exclamation-circle']" class="icon"></font-awesome-icon>
                    <h4>Oops! Something went wrong...</h4>
                    <p>Unfortunately, we couldn't process the Playlistability Index for this track. For more information, please contact us at <a href="mailto:support@playlister.club?subject=Playlistability Index Error">support@playlister.club</a></p>
                  </div>

                </div>
                <div class="cta">

                  <button @click.stop="goHome">Close</button>


                </div>
            </div>
          </div>
          <div class="body loading" v-else>
            <div class="card">
              <font-awesome-icon :icon="['fas', 'compact-disc']" class="icon fa-spin"></font-awesome-icon>
              <p>Loading...Please wait</p>
            </div>

          </div>
          <div class="overlay-blur" v-if="visiblePanel=='playlistabilityIndex'"></div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import SecurityCode from 'vue-security-code';

export default {
  name: 'App',
  components: {
    BarGauge: () => import('./components/BarGauge.vue'),
    Playlistability: () => import('./components/Playlistability.vue'),
    UserAvatar: () => import('./components/UserAvatar.vue'),
    PincodeInput: () => import('vue-pincode-input'),
    MaintenanceShutdownModal: () => import('./components/MaintenanceShutdownModal.vue'),
    NavBar: () => import('./components/NavBar.vue'),
    Footer: () => import('./components/Footer.vue'),
    // SecurityCode: () => import('vue-security-code'),
  },

  computed:{
    playlistabilityBackgroundImage(){
      const vm = this;
      if (typeof (vm.artistImage) != 'undefined' && vm.artistImage != ''){
        return vm.artistImage;
      }
      return vm.songInfo.Image;
    },
    enableValidation(){
      const vm = this;
      if (vm.verificationCode.length == 4) return true;
      return false;
    }
  },
  watch:{
    verificationCode(){
      const vm = this;
      if (vm.verificationCode.length == 4){
        vm.validateCode();
      }
    }
  },
  methods:{
    goHome(){
      window.location = '/';
    },
    generateUUID() {
      let d = new Date().getTime();
      const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
      });
      return uuid;
    },
    isEmailValid(email){
      return !!(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email));
    },
    async onProcessPlaylistabilityIndex(){
      const vm = this;
      vm.playlistabilityError = '';
      let processTrackId = null;

      if (vm.playlistabilityURL.trim() == ''){
        vm.playlistabilityError = 'Please enter a valid Spotify song URL';

        return;
      }
      if (!vm.isEmailValid(vm.playlistabilityEmail)){
        vm.playlistabilityError = 'Please enter a valid email';
        return;
      }
      if (vm.isEmailValid(vm.playlistabilityEmail) && vm.playlistabilityURL.trim() != ''){
        const parsedURL = vm.parsePlaylistabilityURL(vm.playlistabilityURL);

        switch (parsedURL.Type){
          case 'Error':
            vm.playlistabilityError = 'Please enter a valid Spotify song URL';
            return;
          case 'albumURL':
            try {
              const albumSongs = await vm.getAlbumsSongs(parsedURL.Value);

              processTrackId = albumSongs[0].TrackId;
            } catch (err){
              processTrackId = null;
            }
            break;
          default:

            processTrackId = parsedURL.Value;
            break;
        }
        if (processTrackId != null && processTrackId != ''){
          const lead = await vm.processPlaylistabilityTrackId(processTrackId);

          if (lead.Status == 'success' && lead.Guid.length > 0){
            window.location = `/playlistability/?guid=${lead.Guid}`;
          } else {
            vm.playlistabilityError = 'There was an error processing your request. Please try again.';
          }
        } else {
          vm.playlistabilityError = 'Your track URL could not be processed. Please verify the Spotify Song URL is correct and try again.';
        }
      }
    },
    async processPlaylistabilityTrackId(trackId){
      const vm = this;

      vm.processing = true;
      const songInfo = await this.getData(`${this.settings.root}/data/music/slspotify/songinfoall?context=${trackId}`);
      const artistInfo = await this.getData(`${this.settings.root}/data/music/scspotify/getspotifyartistinfo?context=${songInfo[0].ArtistId}`);

      const lead = {
        Guid: this.generateUUID(),
        Email: vm.playlistabilityEmail,
        SpotifySongId: songInfo[0].TrackId,
        SongName: songInfo[0].Name,
        SongDuration: songInfo[0].Duration,
        SongImage: songInfo[0].Image,
        SongPopularity: songInfo[0].Popularity,
        SongPreviewURL: songInfo[0].PreviewURL != '' ? songInfo[0].PreviewURL : null,
        SongReleaseDate: songInfo[0].ReleaseDate,
        SongLabel: songInfo[0].Label,
        SpotifyArtistId: songInfo[0].ArtistId,
        ArtistName: songInfo[0].ArtistName,
        ArtistImage: artistInfo[0].Image,
        Source: 'Playlistability Index',
      };
      const leadInsert = await vm.insertPCLead(lead);
      vm.processing = false;
      return leadInsert;
    },
    async insertPCLead(lead){
      const vm = this;
      try {
        const result = await this.getData(`${this.settings.root}/data/pc/playlists/insertlead?`
        + `guid=${lead.Guid
        }&email=${encodeURIComponent(lead.Email)
        }&source=PlaylistabilityIndex`
        + `&spotifysongid=${lead.SpotifySongId
        }&songname=${encodeURIComponent(lead.SongName)
        }&songduration=${lead.SongDuration
        }&songimage=${encodeURIComponent(lead.SongImage)
        }&songpopularity=${lead.SongPopularity
        }&songpreviewurl=${encodeURIComponent(lead.SongPreviewURL)
        }&songreleasedate=${lead.SongReleaseDate
        }&songlabel=${encodeURIComponent(lead.SongLabel)
        }&spotifyartistid=${lead.SpotifyArtistId
        }&artistname=${encodeURIComponent(lead.ArtistName)
        }&artistimage=${encodeURIComponent(lead.ArtistImage)}`);

        const response = result[0];
        if (typeof (response.Guid) != 'undefined' && response.Guid.length > 0){
          response.Status = 'success';
        }
        return response;
        /*
        guid= lead.Guid
        email= lead.Email
        spotifysongid= lead.SpotifySongId
        songname= encodeURIComponent(lead.SongName)
        songduration= lead.SongDuration
        songimage= encodeURIComponent(lead.SongImage)
        songpopularity= lead.SongPopularity
        songpreviewurl= encodeURIComponent(lead.SongPreviewURL)
        songreleasedate= lead.SongReleaseDate
        songlabel= encodeURIComponent(lead.SongLabel)
        spotifyartistid= lead.SpotifyArtistId
        artistname= encodeURIComponent(lead.ArtistName)
        artistimage= encodeURIComponent(lead.ArtistImage)
         */
      } catch (err){
        console.warn(err);
        return { Guid: '', Status:'fail' };
      }
    },
    async getAlbumsSongs(albumid){
      try {
        const songs = await this.getData(`${this.settings.root}/data/music/slalbumdetailsspotify/songs?context=${albumid}`);

        return songs;
      } catch (err){
        console.warn(err);
        return null;
      }
    },
    parsePlaylistabilityURL(thisurl) {
      const vm = this;
      const parsedSearch = {};
      const searchedTerm = null;
      let category = null;
      let value = null;
      if (thisurl.trim().indexOf('open.spotify.com/') > -1) {
        // it's def. a URL...let's split it up into pieces to figure out what it is
        try {
          //  debugger;
          let tempURL = thisurl.trim();
          tempURL = tempURL.slice(tempURL.indexOf('open.spotify.com/') + 17, tempURL.length);
          category = tempURL.slice(0, tempURL.indexOf('/'));
          value = tempURL.slice(tempURL.indexOf('/') + 1, tempURL.length);
          if (value.indexOf('?') > -1) {
            value = value.slice(0, value.indexOf('?'));
          }
        } catch (err) {
          console.warn(err);
        }

        parsedSearch.Type = `${category}URL`;
        parsedSearch.Value = value;
      } else {
        // not a url
        parsedSearch.Type = 'Error';
        parsedSearch.Value = thisurl.trim();
      }
      return parsedSearch;
    },
    getCategoryDescription(category){
      let description = '';
      switch (category){
        case 'Maturity':
          description = 'Your Song Maturity measures the readiness of your track to be playlisted, purely from a logistical perspective.';
          break;
        case 'Sensation':
          description = 'Your Song Sensation measures the overall feeling, or vibe, that your song elicits, compared to what other curators are adding.';
          break;
        case 'Qualities':
          description = 'Your song’s Sonic Qualities measure the specific instruments and musical elements in your song, compared to what curators are adding.';
          break;
        default:
          description = '';
          break;
      }
      return description;
    },
    goToSignUp(){
      window.location = '/#signup';
    },
    openTrackInSpotify(spotId){
      window.open(`https://open.spotify.com/track/${spotId}`);
    },
    formatUser(playlist) {
      return { Name: playlist.PlaylisterName, UserTier: playlist.PlaylisterTier, Image: playlist.PlaylisterImage };
    },
    getURLParam(paramname) {
      const urlSring = window.location.href;// "http://www.example.com/t.html?a=1&b=3&c=m2-m3-m4-m5"; //window.location.href
      const url = new URL(urlSring);
      const c = url.searchParams.get(paramname);

      return c;
    },

    getData(url) {
      this.initAuthentication($.cookie(this.settings.js_auth_cookie));

      const deferred = $.Deferred();
      $.ajax({
        url,
      }).done((data) => {
        deferred.resolve(data);
      }).fail((error) => {
        console.warn(error);
        deferred.reject(error);
      });
      return deferred;
    },
    initAuthentication(token) {
      // we configure the headers only one time using ajax setup
      // Create an Initialize .js and include it in every page or call in every page that requires authentication.
      const headers = {};
      headers[this.settings.js_appkey_header] = this.settings.js_appkey_value;
      headers['x-auth-token'] = token;
      // headers["Content-Type"] = "application/json";
      $.ajaxSetup({
        headers,
        xhrFields: {
          withCredentials: true,
        },
      });
    },
    async loadPlaylistabilityIndex(songid){
      const vm = this;
      vm.artistGenres = [];
      // /data/music/slspotify/songinfoall?context=7Ci1IrRYYkBwLZ29DT0PId
      // /data/pc/playlists/getsongplaylistability?a=0.000145&d=0.553&e=0.92&i=0.741&p=24&r=08-28-2019&s=0.209&t=152.022&v=0.568
      const songData = await this.getData(`${this.settings.root}/data/music/slspotify/songinfoall?context=${songid}`);
      vm.songInfo = songData[0];

      if (vm.songInfo && vm.songInfo.Acousticness != null){
        const artistGenres = await vm.getData(`${vm.settings.root}/data/music/iartistgenres/byid?context=${vm.songInfo.ArtistId}`);

        if (artistGenres.length > 0){
          artistGenres.forEach((genre) => {
            vm.artistGenres.push(genre.Genre);
          });
          const playlists = await this.getData(`${vm.settings.root}/data/pc/playlists/getmatchingplaylists?genres=${encodeURIComponent(vm.artistGenres.toString())}`);
          vm.suggestedPlaylists = playlists;
          const mainGenres = await vm.getData(`${vm.settings.root}/data/pc/playlists/convertsubgenres?context=${encodeURIComponent(vm.artistGenres.toString())}`);

          if (mainGenres && mainGenres.length > 0){
            const mainGenresStr = mainGenres.map((item) => item.MainGenre).toString();

            vm.onRegisterPixelEvents(mainGenresStr);
          }
          // add suggested playlists here
          // http://api.playlister.club/data/pc/playlists/getmatchingplaylists?genres=chamber%20pop,ok%20indie,stomp%20and%20holler
        }

        const releaseDate = new Date(vm.songInfo.ReleaseDate);
        let releaseMonth = releaseDate.getUTCMonth() + 1;
        if (releaseMonth < 10) { releaseMonth = `0${releaseMonth.toString()}`; }
        let releaseDay = releaseDate.getUTCDate();
        let description = '';

        if (releaseDay < 10) { releaseDay = `0${releaseDay.toString()}`; }
        const releaseYear = releaseDate.getUTCFullYear();
        const playlistabilityData = await this.getData(`${this.settings.root}/data/pc/playlists/getsongplaylistability?`
        + `a=${vm.songInfo.Acousticness
        }&d=${vm.songInfo.Danceability
        }&e=${vm.songInfo.Energy
        }&i=${vm.songInfo.Instrumentalness
        }&p=${vm.songInfo.Popularity
        }&r=${releaseMonth}-${releaseDay}-${releaseYear
        }&s=${vm.songInfo.Speechiness
        }&t=${vm.songInfo.Tempo
        }&v=${vm.songInfo.Valence}`);
        playlistabilityData.forEach((item) => {
          if (item.Category == 'General'){
            description = item.Descriptor;
          }
        });
        vm.playlistability = {
          lowMarker: playlistabilityData[0].Community - playlistabilityData[0].StdDevCommunity,
          highMarker: playlistabilityData[0].Community + playlistabilityData[0].StdDevCommunity,
          value: playlistabilityData[0].Playlistability,
          description,
          ratingLabel: playlistabilityData[0].ScoreType
        };
        vm.playlistabilityDetails = playlistabilityData;
        vm.visiblePanel = 'playlistabilityIndex';
      } else {
        // show error

        vm.visiblePanel = 'requestError';
      }
    },

    onRegisterPixelEvents(genres) {
      try {
        RegisterPixelEvents(genres, 'PLC');
      } catch (err){
        console.warn(err);
      }
    },
    // 724233215655165 668550224357321
    loadCodeRequest(){
      const vm = this;

      vm.visiblePanel = 'requestCode';
    },
    loadRequestInfo(){
      const vm = this;

      vm.visiblePanel = 'requestInfo';
    },
    async checkLeadValidation(){
      const vm = this;
      const piGuid = this.getURLParam('guid');
      if (piGuid != null && piGuid.length > 0){
        vm.userGuid = piGuid;
        const validated = await this.getData(`${this.settings.root}/data/pc/playlists/leademailverified?context=${piGuid}`);

        if (typeof (validated[0]) != 'undefined' && validated[0].EmailVerified == true){
          vm.artistImage = validated[0].ArtistImage;
          vm.loadPlaylistabilityIndex(validated[0].SpotifySongId);
        } else {
          vm.loadCodeRequest();
        }
      } else {
        vm.loadRequestInfo();
        // window.location = '/';
      }
    },
    abbreviateNumber(value) {
      let newValue = value;
      let shortNum;
      if (value >= 1000) {
        const suffixes = ['', 'k', 'm', 'b', 't'];
        const suffixNum = Math.floor((`${value}`).length / 3);
        let shortValue = '';
        for (let precision = 2; precision >= 1; precision--) {
          shortValue = parseFloat((suffixNum != 0 ? (value / (1000 ** suffixNum)) : value).toPrecision(precision));
          const dotLessShortValue = (`${shortValue}`).replace(/[^a-zA-Z 0-9]+/g, '');
          if (dotLessShortValue.length <= 2) { break; }
        }
        if (shortValue % 1 != 0) shortNum = shortValue.toFixed(1);
        newValue = shortValue + suffixes[suffixNum];
      }
      return newValue;
    },
    async validateCode(){
      const vm = this;
      if (vm.userGuid.length > 0){
        vm.visiblePanel = '';
        const valid = false;
        const validate = await this.getData(`${this.settings.root}/data/pc/playlists/verifyleadcode?guid=${vm.userGuid}&code=${vm.verificationCode}`);

        if (validate[0].ReturnValue == '1'){
          this.checkLeadValidation();
        } else {
          vm.verificationError = 'Your access code is invalid. Please try again.';
          vm.visiblePanel = 'requestCode';
        }
      }
    }
  },
  mounted(){},
  beforeMount(){
    this.checkLeadValidation();
  },
  data(){
    return {
      shutdown: false,
      settings: {
        root: 'https://api.songtools.io',
        js_appkey_header: 'x-app-key',
        js_appkey_value: '7945643DACBA4335B27300796E8C392A',
        js_auth_cookie: 'datafx_token_7945643DACBA4335B27300796E8C392A',
        flaggedUsers: ['listdmusic', 'neomusic', 'anchors30', 'geij5q1sj6hrz690l9n3k7l42', 'leoblack0'],
      },
      artistGenres:[],
      songInfo:{
        TrackId: '',
        Name: '',
        Duration: '',
        SongPopularity: '',
        SongPreviewURL: '',
        AlbumName: '',
        SpotifyAlbumId: '',
        Image: '',
        ArtistName: '',
        ArtistImage: '',
        SpotifyArtistId: '',
      },
      suggestedPlaylists:[
        /*
        {
          Id: 45097,
          Name: "La lista Rama",
          Description: "Canciones que traen recuerdos especiales. Photo by Geronimo Giqueaux.",
          Image: "https://i.scdn.co/image/ab67706c0000da84544809ea84e5d7afb449b503",
          Price: 0,
          CPM: "",
          Days: "",
          Autopricing: true,
          Followers: 1,
          LastIndexed: "",
          LastUpdated: "",
          Duration: "",
          UserTier: 4,
          Songs: 108,
          Artists: "",
          SongsPopularity: 14,
          PlaylistId: "4T2u2oooUJB4rJFcPUTUyy",
          SpotifyUser: "rafaelo14",
          UserImage:"https://profile-images.scdn.co/images/userprofile/default/67a9d5670dbeb2426eacb1fa02591b54e46ac52b",
          SpotifyUserDisplayName: "Willyam",
        } */
      ],
      artistImage: '',
      playlistability:{
        lowMarker: 0,
        highMarker:  0,
        value: 0,
        description: '',
      },
      playlistabilityDetails:[],
      visiblePanel:'',
      verificationCode: '',
      verificationError: '',
      userGuid:'',
      playlistabilityURL:'',
      playlistabilityEmail:'',
      playlistabilityError:'',
      processing: false,
    };
  }
};
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css?family=Montserrat:300,400,400i,500,600,700');
  @import url('https://fonts.googleapis.com/css?family=Esteban');
  @import "@/assets/scss/variables.scss";
  .maintenance-container{
    position: fixed;
    top: 0; bottom:0;
    left: 0; right:0;
    display:flex;
    flex-flow: column nowrap;
    place-content: center;
    align-items: center;
    background-color: rgba($color-black, 0.95);
    z-index: 10;
  }
  button{
    background-color: $color-secondary;
    padding: 0.5rem 1rem;
    color: $color-white;
    border-radius: 0.25rem;
    border:none;
    &:hover{
      background-color: lighten($color-secondary, 0.2);
    }
   &:disabled{
     background-color: darken($color-gray,20%);
   }
  }

  .request-error{
    .card{
      display:flex;
      flex-flow: column nowrap;
      .columns{
        flex:1;
      }
      a{
        color: $color-secondary;
      }
      .icon{
        color: $color-danger;
        font-size: 6rem;
        margin: 1rem;
      }
    }
  }
  .request-info{

    .columns{
      position: relative;
      z-index: 2;
      margin: 0 auto;

      display:flex;
      flex-flow: row nowrap;
      justify-content: space-around;
      @media screen and (max-width: $breakpoint-medium){//: 640px !default;

        flex-flow: column-reverse nowrap;
      }
    }
    .gauge-display{
      img{
        width:100%;
        min-width: 360px;
        @media screen and (max-width: $breakpoint-small){//: 640px !default;
        min-width: 0;
        }
      }
    }
    .error{
      font-size: 0.9rem;
      color: $color-white;
      margin-top: 1rem;
      .icon{
        margin-right: 10px;
      }
    }
    p{
      color: lighten($color-darkgray,10%);
    }
    .form-item{
      label{
        font-size: 0.9rem;
        display:block;
        margin-top:1rem;
      }
      input{
        box-shadow: inset 0 4px 5px rgba(black,0.15);
        border-radius: 0.25rem;
        display:block;
        width:100%;
        padding: 0.5rem 1rem;
        border:1px solid darken($color-gray, 10%);
      }
    }
  }
  .loading{
     .card{
        display:flex;
        flex-flow: column nowrap;
        place-content: center;
        color: white;
        background: rgba(0,0,0,0.4);
        text-align: center;
      }

      .icon{
        font-size: 4rem;
        align-self: center;
        color: darken($color-gray, 10%);
        margin-bottom: 1rem;
      }
  }
  .request-code{
     .code{
      margin: 1rem 0 2rem;
      color: black;
    }
    .error{
      color: $color-white;
      margin-bottom: 2rem;
      display:inline-block;
      .icon{
        margin-right: 5px;
      }
    }
    .card{
      display:flex;
      flex-flow: column nowrap;
      place-content: center;
    }
  }
  input.vue-pincode-input{
    font-size: 2rem;
    font-family: "Monsterrat", sans-serif;
    padding: 0.25rem 0.75rem;
    max-width: 50px;
    box-shadow: none;
    border: 2px solid darken($color-gray, 5%);
    &:focus{
      border-color: $color-secondary;
      box-shadow: 0 0 10px 0 rgba($color-black, 0.25);
    }
  }
  .playlist-suggestions{
    display:flex;
    flex-flow: row nowrap;
    @media screen and (max-width: $breakpoint-medium){//: 640px !default;
      flex-flow: column nowrap;
    }
  }
  .playlist{
    display:flex;
    flex:1;
    margin: 0.5rem;
    padding: 0.5rem;
    flex-flow: row nowrap;
    background-color: $color-white;
    position:relative;

    .cover-container{
      width: 75px;
      height: 75px;
      position:relative;
      overflow: visible;

    }
    .playlist-info{
      padding: 0 10px;
      flex:1;
      text-align:left;
      display:flex;
      flex-flow: column nowrap;
      justify-content: center;
      position: relative;
      p{
        margin:0;
        line-height: 100%;
        &.playlist-name{
          font-size: 0.7rem;
          line-height: 1rem;
          font-weight: 500;
          padding-right: 1rem;
          max-height: 3rem;
          overflow:hidden;
          text-overflow: ellipsis;
        }
        &.playlist-author{
          margin-top: 0.5rem;
          font-size: 0.6rem;
          color: $color-darkgray;
        }
        &.playlist-followers{
          align-self: flex-end;
          color: $color-darkgray;
          margin-top: 0.5rem;
        }
      }
    }
    .cover{
      width: auto;
      height: auto;
      position:absolute;
      top:0;
      bottom:0;
      right:0;
      left:0;
      background-size: cover;
      z-index:1;
    }
    .user{
      position:absolute;
      right: -10px;
      top: -15px;
      height: 40px;
      width:40px;
      z-index: 3;
    }
  }
  h6{
    text-transform: uppercase;
  }
  .suggested-playlists{
    width:100%;
    text-align:center;
    margin-top: 1rem;
  }
  .cta{
    padding-top:2rem;
    margin-top: 1rem;
    border-top: 1px solid darken($color-gray, 10%);
    text-align: center;
    width: 100%;
  }
  .scroller{
    position: absolute;
    top:0; bottom: 0;
    right:0; left:0;
    overflow:hidden;
    overflow-y: auto;
  }
  .details{
    margin-top: 2rem;

    h6{
      font-weight: 500;
      font-size: 0.75rem;

    }
  }
  .metric-suggestions{
    display:flex;
    flex-flow: column wrap;
    flex:1;

    .row{
      margin: 0 1rem;
      border-bottom: 1px solid rgba(darken($color-darkgray, 20%),0.1);
      margin-bottom: 1rem;
    }
    h6{
      width: 10vw;
      text-align:left;
      padding-right: 10px;
      flex:1;
      padding-left: 20px;
      position:relative;
      .info-icon{
        position: absolute;
        top:-1px;
        left:0;
        color: lighten($color-darkgray, 30%);

      }
      &:hover{
        .info-icon{
          color: $color-secondary;
        }
        .bubble{
          opacity:1;
          height: 64px;
          bottom: 120%;
        }
      }
      .bubble{
        background-color: $color-darkgray;
        color: $color-white;
        border-radius: 0.25rem;
        box-shadow: 0 0 10px rgba($color-black, 0.5);
        font-size: 0.6rem;
        text-transform: none;

        max-width: 200px;
        text-align: center;
        position:absolute;
        left: -20px;
        bottom: 10px;
        z-index:10;
        transition: all ease-out 250ms;
        opacity:0;
        height: 0;
        span{
          padding: 0.25rem 0.5rem;
          display:block;
          height: 100%;
          width:100%;
          overflow:hidden;
        }
        &:after{
          content: '';
          border: 5px solid transparent;

          border-top-color: $color-darkgray;
          position:absolute;
          bottom: -10px;

          left: 20px;
          z-index:11;
        }
      }
    }
    .bar-gauge{
      height: 15px;
      width: 50px;
    }
    p{
      flex:1;
      font-size: 0.7rem;
      line-height: 150%;
      text-align:left;
      padding-left:1rem;
      color: $color-darkgray;
    }
  }
  .playlistability-details{
    //margin-right: 2rem;
  }
  .song-info{
    padding: 1rem;
    text-align: left;
    position: relative;
    padding-right: 3rem;
    .song-name{
      font-size: 1.3rem;
    }
    .artist-name{
      color: $color-darkgray;
    }
    .spotify-link{
      position: absolute;
      right: 1rem;
      top:1rem;
      width:20px;
      height: 20px;
      color: $color-darkgray;
      cursor:pointer;
      &:hover{
        color: $color-success;
      }
    }

  }
  .gauge-container{
    max-width: 400px;
    margin: 0 auto;
    display:flex;
    flex-flow: column nowrap;
    align-items: center;
    justify-content: center;
    .gauge{
      margin: 0 auto;
    }

  }
    .description{
      text-align: center;
      font-style: italic;
      font-size: 0.9rem;
      padding: 1rem;

    }
  .song-details{
    margin: 1rem 0 0 1rem;
  }
  .cover{
    width: 113px;
    height: 113px;
    background-size:cover;
    border:2px solid $color-white;

  }
  .row{
    display:flex;
    flex-flow: row nowrap;
  }
  .column{
    flex:1;
    display:flex;
    flex-flow: column nowrap;
  }
  html, body{
    width:100%;
    min-height: 100vh;
  }
  .header{
    position: relative;
    z-index:3;
    height: 80px;
    display:flex;
    place-content: center;
  }
  .body{
    flex:1;
    display:flex;
    flex-flow: column nowrap;
    color: $color-white;
    place-content: center;
    justify-content: flex-start;
    position:relative;
  }
  .title{
    font-weight: 300;
    font-size: 2rem;
    margin: 1rem auto;
    color: $color-white;
  }
  .content-container{
    position: relative;
    z-index:2;
    display:flex;
    min-height: 100vh;
    .app-content{
      display:flex;
      flex-flow:column nowrap;
      justify-content: flex-start;
      flex:1;
      max-width: 100%;
    }
  }
.logo-icon{
	text-indent:-9999px;
	width:50px;
	height:30px;
	background: transparent url( $imgpath + 'LogoIconSolid.svg') no-repeat center center;
  background-size:contain;
  display:inline-block;
  margin-left:0;

}
.logo{
	text-indent:-9999px;
	width:140px;
	height:35px;
	background: transparent url( $imgpath + 'LogoIconSolid.svg') no-repeat center center;
	background-size:contain;
	margin-left:2.5rem;
	display:none;
}
.page-width{
	max-width: $breakpoint-large;
	margin: 0 auto;
}
.page-container{
	background: $color-white;
	box-shadow: 0 0 10px 0 rgba(black, 0.5);
	max-width: $breakpoint-large;
	height: 100vh;
	margin: 0 auto;
	margin-top: 2rem;
	position:relative;
	z-index:10;
	border-radius: 0.25rem 0.25rem 0 0;
}
.brand{
  position:relative;
  display:inline-block;
  z-index:10;
  margin:0.5rem;
	text-transform: uppercase;
  position:relative;
  font-size: 1.35rem;
  line-height: 100%;
  align-self: center;
  vertical-align: middle;
  font-weight: 300;
	a{
    text-decoration: none !important;
    color: $color-white !important;
    font-family: 'Montserrat';
  }
	.logo-icon{
    vertical-align: middle;
    margin-right: 0.25rem;
    max-height: 100%;
	}
}
  #app {
    font-family: 'Montserrat', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: $color-black;
    min-height: 100vh;
    position:relative;
    background-color: darken($color-primary, 40%);

  }
  .background{
    background-position: center center;
    background-size: cover;
    position: absolute;
    top:0;
    left:0;
    right:0;
    height: 50vh;
    z-index:1;
    &.internal{
      filter: grayscale(0.75) blur(0px);
      opacity: 0.35;
      height: 50%;


    }
    &.blur{

      filter: blur(20px);
    }
    .gradient-black{
      position: absolute;
      top:0; bottom: 0;
      left: 0; right: 0;
      z-index:2;
      background: linear-gradient(to top, rgba($color-black,1) 0%,  rgba($color-success,0) 100%);
    }
    .gradient-primary{
      position: absolute;
      top:0; bottom: 0;
      left: 0; right: 0;
      z-index:2;
      background: linear-gradient(to top, rgba(darken($color-primary, 40%),1) 50%,  rgba($color-primary,0.5) 100%);
    }
    .gradient-white{
      position: absolute;
      top:0; bottom: 0;
      left: 0; right: 0;
      z-index:2;
      background: linear-gradient(to top, rgba($color-white,1) 0%,  rgba($color-white,0) 100%);
    }
    .gradient-gray{
      position: absolute;
      top:0; bottom: 0;
      left: 0; right: 0;
      z-index:2;
      background: linear-gradient(to top, rgba($color-gray,1) 0%,  rgba($color-gray,0) 100%);
    }
  }
  .card-container{
    display:flex;
    flex-flow: column nowrap;
    padding: 1rem;
  }
  .card{

    border-radius: 1rem;
    background-color: $color-gray;
    width: 80vw;
    max-width: 900px;
    min-height: 400px;
    color: $color-black;
    z-index: 3;
    padding: 2rem;
    position:relative;
    overflow: hidden;
    box-shadow: 0 0 100px 0 rgba($color-black, .75);
    align-self: center;
    margin-bottom: 1rem;
    &:before{
      content: '';
    }
    .card-content.row{
      flex-flow: row wrap;
      position: relative;
      z-index:2;
      padding: 2rem;
    }
  }
</style>

<style lang="scss">
@import "@/assets/scss/variables.scss";

.gauge-display, .details {
  text-align: center;
}

h1 {
  font-size: 38px;
  line-height: 44px;
  margin-top: 20px;
}

label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}
.st-section-playlistability {
    background-color: #000;
    background-image: linear-gradient(to right, #2a0000, #4b0715 58%, rgba(255, 18, 65, .47)), url("https://assets.website-files.com/63bd9a6a8a64796364cd62cc/6436df2be43ce702d3d0e034_gauge-meter.png");
    background-position: 0 0, 160%;
    background-repeat: repeat, no-repeat;
    background-size: auto, auto;
    justify-content: center;
    align-items: center;
    padding: 90px;
    display: flex;
}

.st-section-playlistability {
  min-height: 600px;
  background-image: linear-gradient(to top, #000, rgba(75, 7, 21, .82) 48%, rgba(255, 18, 65, .47)), url("https://assets.website-files.com/63bd9a6a8a64796364cd62cc/643e08f80c6754167ec2bf8c_0_3.png");
  background-position: 0 0, 50% 0;
  background-repeat: repeat, no-repeat;
  background-size: auto, auto 110%;
  background-attachment: scroll, fixed;
  padding-top: 90px;
  transition: all .2s;
  flex: 1;
}

.st-hero-content {
  position: relative;
  z-index: 2500;
  display: flex;
  width: 100%;
  height: auto;
  max-width: 1400px;
  min-height: 300px;
  padding-top: 50px;
  padding-right: 0px;
  padding-left: 120px;
  justify-content: space-between;
  align-items: center;
  align-self: center;
  flex: 1;
}

.st-hero-content.playlistability-center {
  min-height: 400px;
  min-width: 900px;
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
  background-image: linear-gradient(266deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, .71));
  border-radius: 9px;
  padding: 50px;
  background-color: transparent;
}

.service-logo-hero {
  width: auto;
  height: 40px;
  opacity: 0.9;
}

.st-hero-content-left {
  position: relative;
  display: flex;
  width: 55%;
  min-height: 200px;
  flex-direction: column;
  align-items: flex-start;
  color: #f9fafa;
}

.st-hero-content-left.playlistability {
  width: 70%;
  margin-right: auto;
}

.playlistabil-ity-title {
  font-size: 32px;
  margin-bottom: 10px;
}

.h3-slogan {
  opacity: 1;
  text-align: left;
  margin-top: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5em;
}

.playlistability-form-container {
    width: 100%;
    margin-top: 30px;
}

.w-input, .w-select {
  display: block;
  width: 100%;
  height: 38px;
  padding: 8px 12px;
  margin-bottom: 10px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #333333;
  vertical-align: middle;
  background-color: #ffffff;
  border: 1px solid #cccccc;
}

.st-ui-input {
  height: 50px;
  padding-right: 20px;
  padding-left: 20px;
  border: 0px solid #000;
  border-radius: 200px;
  background-color: hsla(0, 0%, 100%, 0.09);
  color: #fff;
  font-size: 16px;

  &:focus-visible {
    outline: none;
  }
}

.btn-primary {
  padding: 12px 20px;
  border-style: solid;
  border-width: 2px;
  border-color: #2e2e2e;
  border-radius: 200px;
  background-color: #f9fafa;
  transition: all 200ms ease;
  color: #2e2e2e;
  font-size: 16px;
  line-height: 20px;
  font-weight: 700;
}

.input-note {
  opacity: .38;
  font-size: 12px;
}

.floating-gauge {
  width: 33%;
  height: 100%;
  opacity: .51;
  mix-blend-mode: overlay;
  background-image: url("https://assets.website-files.com/63bd9a6a8a64796364cd62cc/643fe4b3accfe45b45bdd0f7_gauge-figure.svg");
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: 80%;
  position: absolute;
  top: 0%;
  bottom: auto;
  left: auto;
  right: 0%;
}

@media screen and (min-width: 1920px){
  .st-section-playlistability {
    padding-top: 140px;
    padding-bottom: 120px;
  }

  .st-hero-content.playlistability-center, .st-hero-content.playlistability-verification {
    padding: 70px 60px;
  }
}

@media screen and (min-width: 1440px){
  .st-section-playlistability {
    background-image: linear-gradient(79deg, #140000, #470311 48%, rgba(255, 18, 65, 0)), url("https://assets.website-files.com/63bd9a6a8a64796364cd62cc/643e08f80c6754167ec2bf8c_0_3.png");
    background-position: 0 0, 160%;
    background-repeat: repeat, no-repeat;
    background-size: auto, auto;
  }

  .st-section-playlistability {
    height: 100vh;
    background-image: linear-gradient(to right, #2a0000, rgba(75, 7, 21, .86) 47%, rgba(255, 18, 65, .47)), url("https://assets.website-files.com/63bd9a6a8a64796364cd62cc/643e08f80c6754167ec2bf8c_0_3.png");
    background-position: 0 0, 50%;
    background-repeat: repeat, no-repeat;
    background-size: auto, cover;
    background-attachment: scroll, fixed;
  }

  .service-logo-hero.playlistability {
    max-width: 200px;
  }

  .st-ui-input {
    background-color: hsla(0, 0%, 100%, 0.24);
  }
}

@media screen and (max-width: 991px){
  .st-section-playlistability {
    height: auto;
    background-image: linear-gradient(76deg, #000, #460000 53%, rgba(255, 18, 65, 0)), url("https://assets.website-files.com/63bd9a6a8a64796364cd62cc/6436df2be43ce702d3d0e034_gauge-meter.png");
    background-position: 0 0, -20% 100%;
    background-repeat: repeat, no-repeat;
    background-size: auto, auto;
    padding: 30px;
  }

  .st-section-playlistability {
    min-height: 600px;
    background-image: linear-gradient(to top, #000, rgba(75, 7, 21, .82) 48%, rgba(255, 18, 65, .47)), url("https://assets.website-files.com/63bd9a6a8a64796364cd62cc/643e08f80c6754167ec2bf8c_0_3.png");
    background-position: 0 0, 50% 0;
    background-repeat: repeat, no-repeat;
    background-size: auto, auto 110%;
    background-attachment: scroll, fixed;
    padding-top: 90px;
    transition: all .2s;
  }

  .st-section-playlistability {
    background-position: 0 0, 50%;
    padding-top: 120px;
  }

  .st-hero-content.playlistability-center {
    min-width: 0;
    -webkit-backdrop-filter: blur(4px);
    backdrop-filter: blur(4px);
    background-image: linear-gradient(266deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, .33));
    padding: 30px;
  }

  .playlistabil-ity-title {
    font-size: 28px;
  }

  .h3-slogan {
    text-align: left;
    font-size: 14px;
  }

  .floating-gauge {
    opacity: .13;
    background-position: 100% 0;
  }
}

@media screen and (max-width: 767px){
  .st-section-playlistability {
    background-position: 0 0, 50%;
  }

  .playlistabil-ity-title {
    text-align: left;
    font-size: 25px;
    line-height: 1.4em;
  }

  .floating-gauge {
    background-position: 67% 2%;
  }

  .input-note {
    line-height: 1.4em;
  }
}

@media screen and (max-width: 479px){
  .st-section-playlistability {
    padding: 10px;
  }
  .st-section-playlistability {
    background-position: 0 0, 50%;
    background-size: auto, cover;
    padding-bottom: 100px;
  }

  .st-hero-content.playlistability-center {
    margin-top: 90px;
  }

  .st-hero-content.playlistability-center, .st-hero-content.playlistability-verification {
    padding: 20px;
  }

  .playlistabil-ity-title {
    text-align: left;
    font-size: 20px;
    line-height: 1.5em;
  }

  .h3-slogan {
    text-align: left;
    font-size: 14px;
  }

  .floating-gauge {
    background-position: 58% 2%;
  }
}

//Verification Code
.st-playlistability-hero {
  z-index: 2500;
  width: 100%;
  height: auto;
  max-width: 1400px;
  min-height: 300px;
  flex: 1;
  justify-content: space-between;
  align-self: center;
  align-items: center;
  padding-top: 50px;
  padding-left: 120px;
  padding-right: 0;
  display: flex;
  position: relative;
}

.st-playlistability-hero.playlistability-verification {
  z-index: 200;
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
  background-color: rgba(0, 0, 0, .33);
  background-image: url("https://assets.website-files.com/63bd9a6a8a64796364cd62cc/63c983a39c27131d9d143267_playlisterclub-logo-vector-light.svg");
  background-position: 50% 8%;
  background-repeat: no-repeat;
  background-size: 200px;
  border-radius: 9px;
  flex-direction: column;
  justify-content: center;
  padding: 100px 50px 60px;
  transition: all .2s;
  color: white;
}

.st-hero-content-left.verification {
  flex: 1;
  align-items: center;
}

.playlistability-title {
  margin: 0.67em 0;
  margin-bottom: 10px;
  font-weight: bold;
  margin-top: 20px;
  line-height: 44px;
  text-align: center;
  font-size: 32px;
}

.h3-slogan {
  margin-bottom: 10px;
  opacity: 1;
  text-align: left;
  margin-top: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5em;
}

.h3-slogan.center {
  width: 80%;
  opacity: 1;
  text-align: center;
}

.btn-primary.validate {
  width: 280px;
  margin-left: auto;
}

@media screen and (min-width: 1440px){
  .st-playlistability-hero.playlistability-verification {
    min-height: 400px;
    -webkit-backdrop-filter: blur(12px);
    backdrop-filter: blur(12px);
    justify-content: center;
  }

  .h3-slogan.center {
    text-align: center;
  }
}

@media screen and (min-width: 1920px){
  .st-playlistability-hero.playlistability-verification {
    padding: 100px 60px;
  }

  .st-hero-content-left.playlistability, .st-hero-content-left.verification {
    width: 60%;
  }
}

@media screen and (max-width: 991px){
  .st-playlistability-hero {
    flex-direction: column;
    align-self: flex-start;
    margin-top: 80px;
    padding-left: 30px;
    padding-right: 0;
  }

  .st-playlistability-hero.playlistability-verification, .st-playlistability-hero.playlistability-results {
    min-width: 0;
    -webkit-backdrop-filter: blur(13px);
    backdrop-filter: blur(13px);
    background-image: none;
    margin-top: 0;
    padding: 12px;
  }

  .st-hero-content-left {
    width: 100%;
    margin-top: 80px;
    margin-right: auto;
    padding-top: 0;
  }

  .st-hero-content-left.playlistability, .st-hero-content-left.verification {
    width: 100%;
    margin-top: 0;
  }

  .playlistability-title {
    font-size: 28px;
  }

  .h3-slogan {
    text-align: left;
    font-size: 14px;
  }

  .h3-slogan.center {
    text-align: center;
  }
}

@media screen and (max-width: 767px){
  .playlistability-title {
    text-align: left;
    font-size: 25px;
    line-height: 1.4em;
  }
}

@media screen and (max-width: 479px){
  .st-playlistability-hero.playlistability-center, .st-playlistability-hero.playlistability-verification {
    padding: 20px;
  }

  .playlistability-title {
    text-align: left;
    font-size: 20px;
    line-height: 1.5em;
  }

  .h3-slogan.center {
    text-align: center;
  }
}

//Results
.st-section-playlistability.results {
  z-index: 0;
  min-height: 600px;
  height: auto;
  background-color: rgba(0, 0, 0, .52);
  background-image: linear-gradient(to right, rgba(0, 0, 0, .77) 33%, rgba(0, 0, 0, 0)), var(--bg-image);
  background-position: 0 0, 50%;
  background-repeat: repeat, no-repeat;
  background-size: auto, cover;
  align-items: flex-start;
  padding-top: 120px;
  position: relative;
  transition: all .2s;
}

.overlay-blur {
  z-index: 0;
  width: 100%;
  height: 100%;
  -webkit-backdrop-filter: blur(20px);
  backdrop-filter: blur(20px);
  background-color: rgba(255, 255, 255, .05);
  flex: 1;
  position: absolute;
  top: 0%;
  bottom: 0%;
  left: 0%;
  right: 0%;
}

.playlistab-results {
  z-index: 300;
  width: 100%;
  height: auto;
  max-width: 1400px;
  background-color: rgba(0, 0, 0, .16);
  border-radius: 12px;
  flex-direction: column;
  align-items: flex-start;
  padding: 50px;
  display: flex;
  position: relative;
  color: white;
}

.playlistability-container {
  grid-column-gap: 60px;
  grid-row-gap: 16px;
  grid-template-rows: auto;
  grid-template-columns: 1fr 1fr;
  grid-auto-columns: 1fr;
  display: grid;
}

.gauge-container {
  max-width: unset;
  display: block;
}

.playlistability-description {
  color: rgba(255, 255, 255, .73);
  margin-top: 90px;
  font-size: 14px;
  line-height: 1.5em;
}

.playlistability-songdata-holder {
  background-color: rgba(0, 0, 0, .08);
  border-radius: 6px;
  justify-content: flex-start;
  margin-bottom: 20px;
  padding: 20px;
  display: flex;
  position: relative;
}

.playlistab-song-iconlink {
  opacity: .76;
  cursor: pointer;
  margin-top: 10px;
  margin-right: 10px;
  transition: all .2s;
  position: absolute;
  top: 0%;
  bottom: auto;
  left: auto;
  right: 0%;

  &:hover {
    opacity: 1;
  }
}

.playlistability-song-cover {
  width: 120px;
  height: 120px;
  border-radius: 6px;
  margin-right: 20px;
  transition: all .2s;
  overflow: hidden;
  box-shadow: 2px 0 19px -4px rgba(0, 0, 0, .42);
  background-size: cover;
  background-position: center;
}

.playlistability-song-data {
  flex: 1;
  align-self: center;
}

.playlistab-song-title {
  color: #fff;
  margin-bottom: 0;
  font-size: 20px;
  font-weight: 600;
}

.playlistab-song-artist {
  opacity: .43;
  color: #fff;
  font-size: 13px;
  line-height: 1.5em;
}

.score-title {
  color: #fff;
  flex: 1;
  margin-bottom: 20px;
  font-size: 20px;
  font-weight: 600;
}

.score-block {
  border-bottom: 1px solid rgba(255, 255, 255, .06);
  margin-bottom: 10px;
  padding-bottom: 6px;
}

.score-row {
  align-items: center;
  padding: 6px 12px;
  display: flex;
}

.metric-suggestions h6 .info-icon {
  top: 0;
  color: white;
}

.category-info {
  color: #fff;
  flex: 1;
  font-size: 15px;
  font-weight: 500;
  margin: 0;
}

.playlista-description {
  color: rgba(255, 255, 255, .6);
  font-size: 12px;
}

.playlistab-suggested-playlists-holder {
  width: 100%;
  height: auto;
  min-height: 100px;
  flex-direction: column;
  align-items: center;
  margin-top: 60px;
  padding: 0;
  display: flex;
}

.score-title.center {
  width: 100%;
  text-align: center;
  flex: none;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  font-weight: 600;
  display: flex;
}

.playlistab-subtitle {
  opacity: .68;
  color: #fff;
  flex: 1;
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: 400;
}

.st-suggested-playlists {
  width: 100%;
  height: auto;
  min-height: 50px;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  grid-template-rows: auto;
  grid-template-columns: 1fr 1fr 1fr;
  grid-auto-columns: 1fr;
  display: grid;
}

.playlistability-songdata-holder.lite {
  cursor: pointer;
  background-color: rgba(255, 255, 255, .03);
  transition: all .2s;

  &:hover {
    background-color: rgba(255, 255, 255, .08);
  }
}

.playlistab-song-title.mini {
  font-size: 16px;
}

.playlistab-playlistist-followers {
  opacity: .26;
  color: #fff;
  background-image: url("https://assets.website-files.com/63bd9a6a8a64796364cd62cc/643dd4e5f0e62c53bc605b2e_icon-followers.svg");
  background-position: 0%;
  background-repeat: no-repeat;
  background-size: 14px;
  padding-left: 19px;
  font-size: 11px;
  line-height: 1.3em;
}

.cta {
  padding: 0;
  margin-top: 0;
  border-top: none;
  text-align: center;
  width: 100%;
}

.btn-primary:hover {
  color: #fff;
  background-color: #2ec4b6;
  border-color: #fff;
}

@media screen and (min-width: 1440px){
  .st-section-playlistability.results {
    background-image: linear-gradient(to right, rgba(0, 0, 0, .84), rgba(0, 0, 0, .76) 49%, rgba(0, 0, 0, .45)), var(--bg-image);
    background-size: auto, cover;
  }
}

@media screen and (min-width: 1920px){
  .st-section-playlistability.results {
    padding-bottom: 120px;
  }
}

@media screen and (max-width: 991px){
  .st-section-playlistability.results {
    padding-top: 60px;
    padding-bottom: 60px;
  }

  .playlistab-results {
    margin-top: 40px;
    padding: 30px 15px;
  }

  .playlistability-container {
    grid-column-gap: 60px;
  }

  .playlistability-description {
    margin-top: 40px;
    font-size: 13px;
  }

  .playlistability-songdata-holder {
    align-items: center;
    padding: 12px;
  }

  .playlistability-song-cover {
    width: 80px;
    height: 80px;
    margin-right: 15px;
  }

  .playlistab-song-title {
    font-size: 15px;
  }

  .playlistab-song-iconlink {
    margin: 10px;
  }

  .score-title {
    margin-bottom: 20px;
    font-size: 16px;
  }

  .score-row {
    padding-left: 0;
  }

  .category-info {
    font-size: 13px;
  }

  .playlista-description {
    line-height: 1.4em;
  }

  .playlistab-suggested-playlists-holder {
    grid-column-gap: 770px;
  }

  .score-title.center {
    font-size: 18px;
  }

  .playlistab-subtitle {
    margin-bottom: 20px;
    font-size: 14px;
  }

  .st-suggested-playlists {
    margin-bottom: 28px;
  }

  .playlistability-songdata-holder.lite {
    margin-bottom: 0;
    grid-area: span 1 / span 3 / span 1 / span 3;
  }

  .playlistab-song-title.mini {
    font-size: 14px;
    line-height: 1.4em;
  }
}

@media screen and (max-width: 767px){
  .playlistab-results {
    margin-top: 35px;
  }

  .gauge-container {
    grid-area: span 1 / span 2 / span 1 / span 2;
    align-self: start;
    justify-self: center;
  }

  .playlistability-description {
    line-height: 1.3em;
  }

  .playlistability-details {
    grid-area: span 1 / span 2 / span 1 / span 2;
  }

  .score-title.center {
    margin-bottom: 10px;
    font-size: 16px;
  }

  .playlistab-subtitle {
    text-align: center;
    line-height: 1.5em;
  }
}

@media screen and (max-width: 479px){
  .playlistab-results {
    margin-top: 36px;
  }

  .st-section-playlistability.results {
    padding-left: 15px;
    padding-right: 15px;
  }

  .gauge-container {
    grid-area: span 1 / span 2 / span 1 / span 2;
    align-self: start;
    justify-self: center;
  }

  .playlistability-description {
    font-size: 12px;
  }

  .score-title.center {
    font-size: 15px;
  }

  .playlistab-subtitle {
    font-size: 12px;
    line-height: 1.3em;
  }

  .btn-primary {
    font-size: 14px;
  }
}
</style>
